import { render } from "./PopupFetch.vue?vue&type=template&id=a6c2658c"
import script from "./PopupFetch.vue?vue&type=script&lang=js"
export * from "./PopupFetch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__